import styled from 'styled-components';
import { transparentize } from 'polished';

interface ContainerProps {
  background: string;
  color: string;
  isActive: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: inline;
  position: relative;
  border-radius: 4px;
  background: ${({ isActive, background }) =>
    isActive ? background : transparentize(0.4, background)};
  color: ${({ color }) => color};
  cursor: pointer;
`;
